module.exports = __webpack_public_path__ + "img/consilium-ecuador.7e3138aa.png";